import CampanhaRecompensaResgateModel from "@/models/programafidelidade/campanhaRecompensaResgateModel";

import { IService } from "./base/iService";

export default class CampanhaRecompensaResgateService extends IService<CampanhaRecompensaResgateModel> {
    constructor() {
        super("CampanhaRecompensaResgate");
    }
}
